import { socketSlice } from 'Modules/Socket'
import { takeEvery } from 'typed-redux-saga'
import { closeWsConnection } from './closeWsConnection'
import { subscribeChannels } from './subscribeChannelsSaga'
import { unSubscribeChannels } from './unSubscribeChannelsSaga'

export function* socketSaga() {
	yield* takeEvery(socketSlice.actions.subscribeChannels, subscribeChannels)
	yield* takeEvery(socketSlice.actions.unSubscribeChannels, unSubscribeChannels)
	yield* takeEvery(socketSlice.actions.closeConnection, closeWsConnection)
}
